const _prefix = '@layout/';

export default {
  CHANGE_SIZE: _prefix + 'CHANGE_SIZE',
  CHANGE_MODE: _prefix + 'CHANGE_MODE',
  CHANGE_VISIBILITY: _prefix + 'CHANGE_VISIBILITY',
  CHANGE_HEADER_FIXED: _prefix + 'CHANGE_HEADER_FIXED',
  CHANGE_HEADER_FULL_WIDTH: _prefix + 'CHANGE_HEADER_FULL_WIDTH',
  CHANGE_BACKDROP_VISIBLE: _prefix + 'CHANGE_BACKDROP_VISIBLE',
  UPDATE_CONTENT_PROPS: _prefix + 'UPDATE_CONTENT_PROPS'
};
